import * as React from 'react';
import { Link } from 'react-router';
import FlipkartGoHomeLogo from 'images/grocery/fk_goto_home_logo_small.svg';
import cx from 'classnames';
import omnitureHelper from 'utils/omnitureHelper';
import styles from './Logo.css';
const handleOnGoToFKHomeClick = props => () => {
    const { pageType } = props;
    const omniFields = {
        events: 'event268',
        prop25: `GROCERY:${pageType}`
    };
    omnitureHelper.trackLink(omniFields, 'Go to Flipkart from Grocery');
};
export default function renderGoFKHome(props) {
    return (<Link className={cx(styles['goto-fkhome'])} to={'/'} onClick={handleOnGoToFKHomeClick(props)}>
			<img src={FlipkartGoHomeLogo} alt="Flipkart" title="Flipkart" data-aid="header_logo_go_to_flipkart" className={styles['fk-home-logo']}/>
		</Link>);
}
